import React from 'react';

type AppType = 'ARF' | 'PRB' | 'PRSA';

interface AppTypeBadgeProps {
  type: AppType;
}

const TYPE_CONFIG: Record<AppType, { label: string; classes: string }> = {
  ARF: { label: 'ARF', classes: 'bg-purple-100 text-purple-700' },
  PRB: { label: 'PRB', classes: 'bg-indigo-100 text-indigo-700' },
  PRSA: { label: 'PRSA', classes: 'bg-teal-100 text-teal-700' },
};

const AppTypeBadge = ({ type }: AppTypeBadgeProps) => {
  const config = TYPE_CONFIG[type];
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded text-xs font-caption font-500 ${config.classes}`}>
      {config.label}
    </span>
  );
};

export default AppTypeBadge;
export type { AppType };